import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from "../services/auth.service";
import { LanguageService } from "../services/language.service";

@Injectable({
    providedIn: 'root'
})
export class ConfirmedGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private languageService: LanguageService,
        private router: Router
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        if (this.authService.isAuthenticated() && this.authService.getUser().confirmed) {
            return this.router.createUrlTree(['members', 'modules']);
        }

        return true;
    }

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        if (this.authService.isAuthenticated() && this.authService.getUser().confirmed) {
            return this.router.createUrlTree(['members', 'modules']);
        }

        return true;
    }
}
